import * as $ from 'jquery';

export default class AutocompleteResults {

    private readonly _$el: JQuery;
    private readonly _subscribers: Array<(id: number) => void> = [];
    private readonly _resultClass: string;

    constructor($el: JQuery, resultClass: string) {
        this._$el = $el;
        this._resultClass = resultClass;
        $el.hide();
    }

    public show(): void {
        this._$el.show();
    }

    public hide(): void {
        this._$el.hide();
    }

    public setResults(divs: string[]): void {
        this._$el.html(divs.join(''));

        const subscribers = this._subscribers;
        this._$el
            .find(`> .${this._resultClass}`)

            // The mousedown event is triggered before focusout
            // but the click event is not
            .mousedown(function () {
                const id = $(this).data('id');
                subscribers.forEach(h => h(id));
            });
    }

    public setActiveResult(id: number | null): void {
        this._$el.find('[data-id]').each((_, el) => {
            const $el = $(el);
            $el.toggleClass('active', $el.data('id') === id);
        });
    }

    public onSelect(handler: (id: number) => void): void {
        this._subscribers.push(handler);
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/assets/scripts/services/input-fields/autocomplete/autocomplete-results.ts